var coll = document.getElementsByClassName("kh-collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("kh-active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

const sortSelect = document.querySelector(".main-blog #SortBy");
const wrapper = document.querySelector(".blog-articles");

if (sortSelect != null) {
  sortSelect.addEventListener('change', (event) => {
    const items = document.querySelectorAll(".blog-articles .blog-articles__article");
    var itemsArray = Array.prototype.slice.call(items, 0);

    if (event.target.value == 'title-ascending') {
        
        itemsArray.sort((a, b) => {
            const nameA = a.dataset.title.toUpperCase(); // ignore upper and lowercase
            const nameB = b.dataset.title.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
        });
        
        
    } else if (event.target.value == 'title-descending') {
        itemsArray.sort((a, b) => {
            const nameA = a.dataset.title.toUpperCase(); // ignore upper and lowercase
            const nameB = b.dataset.title.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return 1;
            }
            if (nameA > nameB) {
              return -1;
            }
          
            // names must be equal
            return 0;
        });
    } else {
        itemsArray.sort((a, b) => Number(a.dataset.recent) - Number(b.dataset.recent));
    }

    wrapper.innerHTML = '';

    itemsArray.forEach((item, index) => {
      wrapper.append(item);
    });
  })
}